import { createSelector } from 'reselect';
import { pathOr, prop } from 'ramda';

const state = prop('form');

export const getAdditionalTransmissionReportDocs = createSelector(
  state,
  pathOr([], ['transmissionReportSummary', 'values', 'additionalDocuments']),
);

export const getComments = createSelector(
  state,
  pathOr([], ['detailedEPReport', 'values', 'comments']),
);

export const getPatientInstructions = createSelector(
  // device_status_notes
  state,
  pathOr([], ['detailedEPReport', 'values', 'device_status_notes']),
);

export const getDeviceReportFindings = createSelector(
  // device_status_recommendations
  state,
  pathOr([], ['detailedEPReport', 'values', 'device_status_recommendations']),
);
